export class CreateKPIShipmentCusViewModel {
    isEnabled: any;
    cusId: number;
    kPIShipmentId: number;
}